export default __webpack_public_path__ + "media/images/floppy-1-eef7514c7664c54a480dc020ee603f26.svg";